import * as React from 'react';
import * as styles from "./Panel.css";
import { MessagesStore } from '../stores';
import { inject, observer } from 'mobx-react';
import { IAPanel } from '../../panels/Panel';
import { IAChoiceGroup } from '../../choiceGroup/ChoiceGroup';
import { IAPeopleSearch } from '../../peopleSearch/PeopleSearch';
import { IUser } from '../../../interfaces/IUser';
import { Helper } from '../../../Helper';
import { IADateAndTimePicker } from '../../dateAndTimePicker/DateAndTimePicker';
import { IAIcon } from '../../icon/Icon';
import { LocalizationService } from '../../../services/LocalizationService';
import { IATreeview } from '../../treeview/Treeview';
import { ITreeViewItem } from '../../../interfaces/ITreeViewItem';

export interface IFilterPanelProps {
  open: boolean;
  messagesStore?: MessagesStore;
  clearFiltersKey?: string;
  reloadMessages: () => void;
}

export interface IFilterPanelState {
  authorExpand: boolean;
  contactsExpand: boolean;
  dateExpand: boolean;
  categoriesExpand: boolean;
  availableCategoriesForComponent: any[];
}

@inject('messagesStore')
@observer
export class FilterPanel extends React.Component<IFilterPanelProps, IFilterPanelState> {

  private readonly localizationService: LocalizationService = new LocalizationService();

  constructor(props: IFilterPanelProps) {
    super(props);
    this.state = {
      authorExpand: false,
      contactsExpand: false,
      dateExpand: true,
      categoriesExpand: true,
      availableCategoriesForComponent: undefined
    };
    this.localizationService?.checkLocalizedStrings().then(() => this.forceUpdate());
  }

  public componentWillReceiveProps(props: IFilterPanelProps): void {
    if (this.props.clearFiltersKey !== props.clearFiltersKey || this.props.open !== props.open) {
      this.loadCategories();
    }
  }

  private childrenCategoriesAreChecked(category: any, id: string): void {
    if (category.children) {
      category.children.forEach((child: any) => {
        if (id === child.guid) {
          child.checked = true;
        }
        this.childrenCategoriesAreChecked(child, id);
      });
    }
  }

  private loadCategories(): void {
    this.props.messagesStore.availableCategoriesForComponent = undefined;
    this.props.messagesStore.getCategories().then(() => {
      const categoryDataItems = JSON.stringify(this.props.messagesStore.categoryDataItems);
      const categoryData = JSON.parse(categoryDataItems) as ITreeViewItem[];
      this.props.messagesStore.availableCategoriesForComponent = categoryData;
      this.setState({
        availableCategoriesForComponent: this.checkCategories(categoryData)
      });
    });
  }

  private checkCategories(categories: ITreeViewItem[]): ITreeViewItem[] {
    return categories.map((item) => {
      return {
        ...item,
        checked: this.props.messagesStore.filterData?.selectedCategories?.some((selectedCategory) => selectedCategory.id === item.guid),
        children: item.children ? this.checkCategories(item.children) : [],
      };
    });
  }

  private hasSelectedChild(item: ITreeViewItem): void {
    item.children?.forEach((child: ITreeViewItem) => {
      if (child.checked) {
        this.props.messagesStore.filterData.selectedCategories.push(
          {
            id: child.guid,
            name: child.name
          }
        );
      }
      this.hasSelectedChild(child);
    });
  }

  public render(): JSX.Element {
    if (this.props.messagesStore.showFilterPanel) {
      this.props.messagesStore.getCategories();
    }
    let content = (
      <div>
        <div className={'categories'}>
          <div className={styles.IA_expandHeader}
            onClick={() => {
              this.setState({ categoriesExpand: !this.state.categoriesExpand }, () => this.forceUpdate());
            }}
          >
            <div
              className={styles.IA_expandButton}
              style={{
                color: this.props.messagesStore.highlightColor
              }}
            >
              <IAIcon
                url={this.state.categoriesExpand ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"}
                size={18}
                color={"#767676"}
              />
            </div>
            <div className={styles.IA_filterTitle}>
              {new LocalizationService().strings.Messages_FilterPanel_Categories}
            </div>
          </div>
          {this.state.categoriesExpand &&
            <div className={styles.IA_viewPanelContentWrapper}>
              {this.props.messagesStore.availableCategoriesForComponent &&
                <IATreeview
                  highlightColor={this.props.messagesStore.highlightColor}
                  actionType="Checkbox"
                  expanded={false}
                  structureType="Arrow"
                  useColors
                  onChange={(items: ITreeViewItem[]) => {
                    this.setState({ availableCategoriesForComponent: items });
                    this.props.messagesStore.filterData.selectedCategories = [];
                    items.forEach((item: ITreeViewItem) => {
                      if (item.checked) {
                        this.props.messagesStore.filterData.selectedCategories.push({
                          id: item.guid,
                          name: item.name
                        })
                      }
                      this.hasSelectedChild(item);
                    });
                    setTimeout(() => {
                      this.props.messagesStore.filterData.isFiltered = true;
                      this.props.messagesStore.updateFilter(this.props.messagesStore.filterData);
                      this.props.reloadMessages();
                    }, 1000);
                  }}
                  items={this.state.availableCategoriesForComponent}
                />
              }
            </div>
          }
        </div>

        <div className={styles.IA_filterPanelSpace} />

        <div className={"Date"}>
          <div className={styles.IA_expandHeader}
            onClick={() => {
              this.setState({ dateExpand: !this.state.dateExpand }, () => this.forceUpdate());
            }}
          >
            <div
              className={styles.IA_expandButton}
              style={{
                color: this.props.messagesStore.highlightColor
              }}
            >
              <IAIcon
                url={this.state.dateExpand ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"}
                size={18}
                color={"#767676"}
              />
            </div>
            <div className={styles.IA_filterTitle}>
              {new LocalizationService().strings.Messages_FilterPanel_Date}

            </div>
          </div>
          {this.state.dateExpand &&
            <div className={styles.IA_viewPanelContentWrapper}>
              <IAChoiceGroup
                className={styles.IA_defaultChoiceGroup}
                selectedKey={this.props.messagesStore.filterData.showPeriodMessage}
                highlightColor={this.props.messagesStore.highlightColor}
                options={[
                  {
                    key: 'All time',
                    text: new LocalizationService().strings.Messages_FilterPanel_AllTime,
                    disabled: false
                  },
                  {
                    key: 'Period',
                    text: new LocalizationService().strings.Messages_FilterPanel_Period,
                    disabled: false
                  }
                ]}
                required={true}
                onChange={(key) => {
                  let filterData = this.props.messagesStore.filterData;
                  filterData.showPeriodMessage = key;
                  filterData.isFiltered = true;
                  this.props.messagesStore.updateFilter(filterData);
                  this.props.reloadMessages();
                }}
                style={{
                  marginTop: 10
                }}
              />
              <IADateAndTimePicker
                label={new LocalizationService().strings.Messages_FilterPanel_StartTime}
                selectedDate={this.props.messagesStore.filterData.startDate}
                showTimeSelector={true}
                highlightColor={this.props.messagesStore.highlightColor}
                isClearable={true}
                disabled={this.props.messagesStore.filterData.showPeriodMessage === "All time"}
                onChange={(startDate: Date) => {
                  let filterData = this.props.messagesStore.filterData;
                  filterData.startDate = startDate;
                  filterData.isFiltered = true;
                  filterData.showPeriodMessage = 'Period';
                  this.props.messagesStore.updateFilter(filterData);
                  this.props.reloadMessages();
                }}
                style={{
                  marginTop: 0,
                  width: 200,
                  // opacity: 0.5
                }}
              />
              <IADateAndTimePicker
                label={new LocalizationService().strings.Messages_FilterPanel_EndTime}
                selectedDate={this.props.messagesStore.filterData.endDate}
                showTimeSelector={true}
                highlightColor={this.props.messagesStore.highlightColor}
                isClearable={true}
                disabled={this.props.messagesStore.filterData.showPeriodMessage === "All time"}
                onChange={(endDate: Date) => {
                  let filterData = this.props.messagesStore.filterData;
                  filterData.endDate = endDate;
                  filterData.isFiltered = true;
                  filterData.showPeriodMessage = 'Period';
                  this.props.messagesStore.updateFilter(filterData);
                  this.props.reloadMessages();
                }}
                style={{
                  marginTop: 10,
                  marginBottom: 10,
                  width: 200,
                  // opacity: 0.5
                }}
              />
            </div>
          }
        </div>
        {this.props.messagesStore.component === "Messages" &&
          <div className={styles.IA_filterPanelSpace} />
        }
        {this.props.messagesStore.component === "Messages" &&
          <div className={"Contacts"}>
            <div className={styles.IA_expandHeader}
              onClick={() => {
                this.setState({ contactsExpand: !this.state.contactsExpand }, () => this.forceUpdate());
              }}
            >
              <div
                className={styles.IA_expandButton}
                style={{
                  color: this.props.messagesStore.highlightColor
                }}
              >
                <IAIcon
                  url={this.state.contactsExpand ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"}
                  size={18}
                  color={"#767676"}
                />
              </div>
              <div className={styles.IA_filterTitle}>
                {new LocalizationService().strings.Messages_FilterPanel_Contacts}

              </div>
            </div>
            {this.state.contactsExpand &&
              <div className={styles.IA_viewPanelContentWrapper}>

                <IAPeopleSearch
                  token={this.props.messagesStore.token}
                  tenant={this.props.messagesStore.tenant}
                  environment={this.props.messagesStore.environment}
                  multiSelection={true}
                  selectedValues={this.props.messagesStore.filterData.selectedPeolple}
                  onSelect={(people: IUser[]) => {
                    if (people != undefined) {
                      people.forEach((contact: any) => {
                        contact = Helper.syncUserProperties(contact);
                      });
                    }
                    let filterData = this.props.messagesStore.filterData;
                    filterData.selectedPeolple = people;
                    filterData.isFiltered = true;
                    this.props.messagesStore.updateFilter(filterData);
                    this.props.reloadMessages();
                  }}
                  style={{
                    marginTop: 10,
                    marginBottom: 10
                  }}
                />
              </div>
            }
          </div>
        }
        {this.props.messagesStore.component === "Messages" &&
          <div className={styles.IA_filterPanelSpace} />
        }
        {this.props.messagesStore.component === "Messages" &&
          <div className={"Author"}>
            <div className={styles.IA_expandHeader}
              onClick={() => {
                this.setState({ authorExpand: !this.state.authorExpand }, () => this.forceUpdate());
              }}
            >
              <div
                className={styles.IA_expandButton}
                style={{
                  color: this.props.messagesStore.highlightColor
                }}
              >
                <IAIcon
                  url={this.state.authorExpand ? "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Down/SVG/ic_fluent_chevron_down_48_regular.svg" : "https://intraactivestorage.blob.core.windows.net/cdn/icons/Chevron%20Up/SVG/ic_fluent_chevron_up_48_regular.svg"}
                  size={18}
                  color={"#767676"}
                />
              </div>
              <div className={styles.IA_filterTitle}>
                {new LocalizationService().strings.Messages_FilterPanel_Author}
              </div>
            </div>
            {this.state.authorExpand &&
              <div className={styles.IA_viewPanelContentWrapper}>
                <IAChoiceGroup
                  className={styles.IA_defaultChoiceGroup}
                  selectedKey={this.props.messagesStore.filterData.showOnlyAuthorMessages}
                  highlightColor={this.props.messagesStore.highlightColor}
                  options={[
                    {
                      key: 'Me',
                      text: this.localizationService.strings.Messages_FilterPanel_Me,
                      disabled: false
                    },
                    {
                      key: 'All',
                      text: this.localizationService.strings.Messages_FilterPanel_All,
                      disabled: false
                    }
                  ]}
                  required={true}
                  onChange={(key) => {
                    let filterData = this.props.messagesStore.filterData;
                    filterData.showOnlyAuthorMessages = key;
                    filterData.isFiltered = true;
                    this.props.messagesStore.updateFilter(filterData);
                    this.props.reloadMessages();
                  }}
                  style={{
                    marginTop: 10
                  }}
                />
              </div>
            }
          </div>
        }
        <div className={styles.IA_filterPanelSpace} />
      </div>
    );
    let top = 0;
    if (document.getElementById("IA_navigator_bar")) {
      top = 40;
    }
    if (!this.props.messagesStore.inTeams && (Helper.getDisplayEnvironment() === "Sharepoint" || Helper.getDisplayEnvironment() === "SharepointClassic") && document.getElementById("IA_navigator_bar")) {
      top = 88;
    }
    if (this.props.messagesStore.isAdminPage && location.href.indexOf("intraactive-admin") !== -1) {
      top = 109;
    }
    if (this.props.messagesStore.isMobileApp) {
      top = window.platform === "android" ? 50 : Helper.isIPhoneXType() ? 90 : 70;
    }
    return (
      <IAPanel
        showNavigationBar={true}
        open={this.props.open}
        transition={this.props.messagesStore.panelIsOpen ? "fade" : "slide"}
        width={this.props.messagesStore.isMobile ? window.innerWidth : 400}
        isMobile={this.props.messagesStore.isMobile}
        highlightColor={this.props.messagesStore.highlightColor}
        marginTop={top}
        close={() => {
          this.props.messagesStore.showFilterPanel = false;
        }}
        onClearFilters={() => {
          this.props.messagesStore.updateFilter({
            isFiltered: false,
            showOnlyAuthorMessages: "All",
            showPeriodMessage: "All time",
            selectedPeolple: [],
            selectedCategories: [],
            startDate: undefined,
            endDate: undefined,
          });

          this.loadCategories();
          this.props.reloadMessages();
        }}
      >{content}</IAPanel>
    );
  }


}